import React from 'react';
import Box from '@mui/material/Box';

interface SectionProps {
  children: React.ReactNode;
  background?: string;
  dark?: boolean;
  maxWidth?: number;
  py?: Record<string, number> | number;
  id?: string;
  sx?: Record<string, any>;
}

export default function Section({
  children,
  background = '#FFFFFF',
  dark = false,
  maxWidth = 1200,
  py = { xs: 6, md: 10 },
  id,
  sx,
}: SectionProps) {
  return (
    <Box
      id={id}
      component="section"
      sx={{
        width: '100%',
        backgroundColor: background,
        color: dark ? '#FFFFFF' : '#1a1a1a',
        ...sx,
      }}
    >
      <Box
        sx={{
          maxWidth,
          mx: 'auto',
          px: { xs: 3, md: 6 },
          py,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
